import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../../components/NtText";
import colors from "../../../config/colors";

function NtCaseStudyTitle({ style, ...otherProbs }) {
  return <NtText style={[styles.text, style]} {...otherProbs} />;
}

const styles = StyleSheet.create({
  container: {},
  text: {
    color: "white",
    fontSize: 25,
    fontWeight: "600",
  },
});

export default NtCaseStudyTitle;
